import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Error = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path
                d="M21.5 26.5C21.5 27.3284 20.8284 28 20 28C19.1716 28 18.5 27.3284 18.5 26.5C18.5 25.6716 19.1716 25 20 25C20.8284 25 21.5 25.6716 21.5 26.5Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20ZM20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6ZM20 10C20.5523 10 21 10.4477 21 11V21.5C21 22.0523 20.5523 22.5 20 22.5C19.4477 22.5 19 22.0523 19 21.5V11C19 10.4477 19.4477 10 20 10Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Error;
